import React from "react";

type LinkedinSendersCampaignsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export default function LinkedinSendersCampaignsModal({ isOpen, onClose }: LinkedinSendersCampaignsModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/[0.31] p-4"
      role="dialog"
      aria-modal="true"
    
    >
      <div className="w-full max-w-[580px] rounded-[12px] bg-white p-6">
        <div className="relative rounded-[12px] bg-bg-light-blue px-6 py-12 text-center">
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="absolute right-4 top-4 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/70 text-dark-grey hover:bg-white"
          >
            <img src="/icons/x_circle.svg" alt="" aria-hidden="true" className="h-6 w-6" />
          </button>

          <img src="/icons/linkedin.svg" alt="" aria-hidden="true" className="mx-auto h-12 w-12" />
          <h3 className="mt-4 text-md font-semibold text-dark-black">LinkedIn Senders In Multiple Campaigns</h3>

          <p className="mx-auto mt-4 max-w-[620px] text-sm text-dark-black">
            The selected LinkedIn accounts are already active in another campaign. This may result in fewer actions
            executed per day than the limits you set, as these senders will share their limits between all campaigns
            they are active in. Are you sure you want to continue?
          </p>
        </div>
      </div>
    </div>
  );
}
